/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at

 * http://www.apache.org/licenses/LICENSE-2.0

 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import Widget from './Widget'
import TechnicalIndicatorView from '../view/TechnicalIndicatorView'
import TechnicalIndicatorOverlayView from '../view/TechnicalIndicatorOverlayView'

export default class TechnicalIndicatorWidget extends Widget {
  _createMainView (container, props) {
    return new TechnicalIndicatorView(container, props.chartStore, props.xAxis, props.yAxis, props.paneId)
  }

  _createOverlayView (container, props) {
    return new TechnicalIndicatorOverlayView(container, props.chartStore, props.xAxis, props.yAxis, props.paneId)
  }
}
